/*
*	Front Page Menu
*/
jQuery(document).ready(function($) {

	// if ($('.menu-frontpage-links-container').length) {
	// 	$('.menu-item-has-children').attr('aria-haspopup','true');
	// 	$('.menu-item-has-children').attr('aria-expanded','false');
	// }
	//
	// $('.menu-item-has-children').click(function() {
	// 	$('.menu-item-has-children').attr('aria-expanded','true');
	// });

	// seems like the menu is just opening via css...

	// console.log ( $('.sub-menu').is(':focus').length );
	//
	//
	// if ( $('.sub-menu').children().is(':focus').length > 0 ) {
	// 	$(this).css('opacity', '1');
	// 	console.log('hit');
	// };

	// $('.sub-menu').hide();

	// $("#menu-frontpage-links").on('keydown', '#textbox', function(e) {
	//   var keyCode = e.keyCode || e.which;
	//
	//   if (keyCode == 9) {

	 $("#menu-frontpage-links").keydown(function () {
		 // if ($('.menu-item-2061 a, .sub-menu').is(':focus') || $('.menu-item-2061 a, .sub-menu:hover').length != 0) {
		if ($('.menu-item-2061 a').is(':focus')) {
	 		// $('.sub-menu').show();
			$('.sub-menu').css('opacity','1');
			$('.menu-item-2061').css('background-color','#982d37');
	 	} else {
			// $('.sub-menu').hide();
			$('.sub-menu').css('opacity','0');
			$('.menu-item-2061').css('background-color','#454545');
		}
	 });


});